import {
  Control,
  Controls,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { Department } from '@trustero/trustero-api-web/lib/model/department_pb'
import {
  PolicyRecord,
  PolicyRecords,
} from '@trustero/trustero-api-web/lib/model/policy_pb'
import FileSaver from 'file-saver'
import * as CSV from 'csv-string'
import { controlStatusTitle } from '../../lib/common/types'
import { NONE_NAME } from '../globalConstants'

const CONTROLS_CSV_HEADERS = [
  'Control ID,Objective,Procedure,Status,Framework,Assignee,Department,Policy',
]

// Turns something like `trf-soc2-CC1.1` into `CC1.1`
const extractFramework = (id: string): string => {
  return id
    .match(/[A-Z]+\d.\d+/g)
    ?.values()
    .next().value
}

const generateControlsReport = async (
  controls: Control[],
  policies: Record<string, PolicyRecord>,
  departments: Record<string, Department>,
): Promise<Blob> => {
  const data = await Promise.all(
    controls.map((control: Control) => {
      const department = departments[control.getDepartmentId()]
      return [
        control?.getModelId() ?? '',
        control.getObjective().replace('##', '').trim(),
        control.getDescription().trim(),
        controlStatusTitle[control.getStatus()],
        control
          .getFrameworkIdsList()
          .map((frameworkModelId: string) => extractFramework(frameworkModelId))
          .join(' '),

        control?.getOwnerEmail() ?? '',
        department?.getName() ?? NONE_NAME,
        policies[control.getPolicyId()]?.getName() ?? NONE_NAME,
      ]
    }),
  )
  const csvRows = CONTROLS_CSV_HEADERS.concat(CSV.stringify(data)).join('\r\n')
  return new Blob([csvRows], { type: 'text/csv;charset=utf-8;' })
}

export const DownloadControlsReport = async (
  controls: Controls | undefined,
  policies: PolicyRecords | undefined,
  departments: Department[] | undefined,
): Promise<void> => {
  const ctrls = controls?.getItemsList() || []
  const policiesMap = (policies?.getItemsList() || []).reduce(
    (acc: Record<string, PolicyRecord>, policy: PolicyRecord) => {
      acc[policy.getModelId()] = policy
      return acc
    },
    {},
  )
  const deptMap = (departments || []).reduce(
    (acc: Record<string, Department>, dept: Department) => {
      acc[dept.getId()] = dept
      return acc
    },
    {},
  )

  const csv = await generateControlsReport(ctrls, policiesMap, deptMap)
  await FileSaver.saveAs(csv, 'control-status.csv')
}
